/* Registers the PWA service worker + hot-updates the app the moment a new
   build lands on the server. No manual cache-clear needed. */
export function registerSW() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  if (window.location.protocol !== "https:" && window.location.hostname !== "localhost") return;

  window.addEventListener("load", async () => {
    let refreshed = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshed) return;
      refreshed = true;
      window.location.reload();
    });

    let reg;
    try {
      reg = await navigator.serviceWorker.register("/service-worker.js", { scope: "/" });
    } catch (e) {
      console.warn("SW registration failed", e);
      return;
    }

    const activateWaiting = (worker) => worker && worker.postMessage({ type: "SKIP_WAITING" });

    if (reg.waiting) activateWaiting(reg.waiting);
    reg.addEventListener("updatefound", () => {
      const nw = reg.installing;
      if (!nw) return;
      nw.addEventListener("statechange", () => {
        if (nw.state === "installed" && navigator.serviceWorker.controller) activateWaiting(nw);
      });
    });

    // Poll every 30s (and on tab focus) for a new build
    const checkForUpdate = () => reg.update().catch(() => {});
    setInterval(checkForUpdate, 30_000);
    window.addEventListener("focus", checkForUpdate);
    window.addEventListener("online", checkForUpdate);
  });
}
